import { render, staticRenderFns } from "./Rateio.vue?vue&type=template&id=70aab972"
import script from "./Rateio.vue?vue&type=script&lang=js"
export * from "./Rateio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports